import tonStyles from './../ton.json'

export default {
  name: 'B4',
  color: tonStyles.colors.PrimaryBlack,
  fontStyle: 'italic'
}
